var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#C0B87F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5208 4.06519C9.6736 3.6049 10.3264 3.6049 10.4792 4.06519L11.7874 8.0062H15.9943C16.4855 8.0062 16.6873 8.63513 16.2873 8.9196L12.8921 11.334L14.194 15.256C14.3475 15.7182 13.8193 16.1068 13.4218 15.8242L10 13.3908L6.5782 15.8242C6.18075 16.1068 5.65253 15.7182 5.80595 15.256L7.10786 11.334L3.71269 8.9196C3.31267 8.63513 3.51445 8.0062 4.00574 8.0062H8.21256L9.5208 4.06519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBadge);
export default __webpack_public_path__ + "static/media/starBadge.26a8b8c10d23801110dd6a35ec2b2625.svg";
export { ForwardRef as ReactComponent };